export default __webpack_public_path__ + "static/media/movie.38a4b327.png";